import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import { ticketValidation } from '../../redux/actions/ticketValidationAction'
import { useNavigate, useParams } from 'react-router-dom'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import CommonQr from '../../global/ScanQrCode/CommonQr'

function ScanAutoValidationQr(props) {
    const navigate = useNavigate()
    const [isDataRecorded, setIsDataRecorded] = useState(false)
    const { dispatch, notify, partnerDetails } = props
    const { partner } = useParams()

    const handleScan = (data) => {
        let qrcodeId = data?.text?.split('/').pop()

        const pushBack = JSON.parse(localStorage.getItem('history'))
        const ticketDetails = JSON.parse(localStorage.getItem('paymentRecipt'))
        if (data?.text) {
            if (!isDataRecorded) {
                setIsDataRecorded(true)
                if (qrcodeId) {
                    apifuntocall(qrcodeId, ticketDetails && ticketDetails.ticket_number)
                } else {
                    notify('error', 'Invalid QR Code, Please scan a valid QR!')
                    navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
                }
                setIsDataRecorded(true)
            }
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => { }
    const handleError = () => {
        setIsDataRecorded(true)
    }

    const apifuntocall = (qrcodeId, ticketNumber) => {
        setIsDataRecorded(true)
        const payload = { 'ticket_number': ticketNumber, channel: 'web', business_qrcode: qrcodeId }
        dispatch(ticketValidation(payload)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                navigate(`/${partner}/paymentResponse`)
                notify('success', 'E-Ticket has been validated successfully.')
            } else {
                notify(
                    'error',
                    res?.errors?.message
                        ? res?.errors?.message
                        : errorMessage?.somethingWentWrong
                )
                navigate(`/${partner}/paymentResponse`)
            }
        })
    }

    return (
        <div>
            <CommonQr
                isDisplayBack={true}
                isHeader={true}
                noLoginIcon={true}
                title="Ticket Validation"
                subTitle="Please Scan the Business QR Code to validate Ticket."
                isParentCss={false}
                partnerDetails={partnerDetails}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
            />
        </div>
    )
}

ScanAutoValidationQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object
}

ScanAutoValidationQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    notify: noop,
    partnerDetails: EMPTY_OBJECT
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanAutoValidationQr)
